import {getFormJsonData} from '../utils/form';
import {AppContext} from '../utils/app-init';
declare const dataLayer:any[];

export class GrdfLeadForm {
	constructor(protected formEl: HTMLFormElement, protected formParentEl: HTMLElement, protected context: AppContext, protected redirect: boolean = true) {
	}

	get submitEl(): NodeListOf<HTMLInputElement> {
		return this.formEl.querySelectorAll('button[type=submit]');
	}

	get inputEls(): NodeListOf<HTMLInputElement> {
		return this.formEl.querySelectorAll('input, textarea, select');
	}

	get customTextEl(): HTMLParagraphElement {
		return this.formParentEl.querySelector('.custom-text') as HTMLParagraphElement;
	}

	get customTextOpenEl(): HTMLParagraphElement {
		return this.formParentEl.querySelector('.custom-text-detail') as HTMLParagraphElement;
	}

	public async submit() {
		this.submitEl.forEach(submitEl => {submitEl.classList.add('disabled');});
		const formData = getFormJsonData(this.formEl);
		if(formData?.phone) formData.phone = formData.phone.replace(/\D/ig, '');
		try {
			const response = await fetch(`/api/express/${this.context.NetworkSlug}/${this.context.OperationId}/${this.context.FranchiseSlug}/register-lead`, {
				credentials: 'same-origin',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				method: 'POST',
				body: JSON.stringify({campaignId: this.context.CampaignId, ...formData})
			});

			const data = await response.json();

			if(response.ok) {
				dataLayer.push({'event': 'page', 'pageName': '/registration-confirmation'});

				if(this.redirect) {
					window.location.pathname += '/registration-confirmation';
				}
				else {
					this.formParentEl.classList.add('completed');
				}
			}
			console.log(response.ok, data);
		} catch(e) {
			console.log(e);
		}
		this.submitEl.forEach(submitEl => {submitEl.classList.remove('disabled');});
	}

	public initFormInputBehavior() {
		this.submitEl.forEach(submitEl => {
			submitEl.onclick = async (e) => {
				this.inputEls.forEach((input) => {
					if(!input.classList.contains('dirty')) {
						input.classList.add('dirty');
					}
				});
			};
		});

		this.inputEls.forEach((input) => {
			input.addEventListener('click', toggleDirtyClass);
		});

		function toggleDirtyClass(e: FocusEvent) {
			const input = e.target as Element;
			if(!input.classList.contains('dirty')) {
				input.classList.add('dirty');
				input.removeEventListener('click', toggleDirtyClass);
			}
		}

		this.formEl.addEventListener('submit', async (event) => {
			event.preventDefault();
			if(this.formEl.checkValidity()) {
				await this.submit();
			}
		});

		return this;
	}

	public initCustomText() {
		if(this.customTextEl.scrollHeight > this.customTextEl.clientHeight) {
			this.customTextOpenEl.onclick = async (e) => {
				this.customTextOpenEl.classList.add('hide');
				this.customTextEl.classList.add('open');
			};
		}
		else {
			this.customTextOpenEl.classList.add('hide');
			this.customTextEl.classList.add('open');
		}
		return this;
	}
}
